import AnimatedImage from '../components/AnimatedImage/AnimatedImage';

const Home = () => {
    return (
        <main className="flex-row large-gap mobile-flip">
            <section className="flex-column large-gap">
                <div className="home-content flex-row medium-gap mobile-flip">
                    <p className="text-body">
                        I'm Parker Anderson, a Computer Science, Cognitive Science, and Math student at the University of Georgia. 
                        I'm interested in the intersection of technology and human cognition, and I explore this through my studies in artificial intelligence, human-computer interaction, and neuroscience. 
                    </p>
                    <figure>
                        <AnimatedImage alt="SQL Injection Lecture" src={require('../assets/images/lecture.webp')} className="home-content__image" />
                        <figcaption className="text-caption text-center">SQL Injection Lecture / UGA SCS</figcaption>
                    </figure>
                </div>
                <div className="home-content flex-row medium-gap mobile-flip">
                    <figure>
                        <AnimatedImage alt="Human Race 5K" src={require('../assets/images/humanrace.webp')} className="home-content__image" />
                        <figcaption className="text-caption text-center">Human Race 5K / Athens, GA</figcaption>
                    </figure>
                    <p className="text-body">
                        I also leverage data-driven insights to identify opportunities and optimize financial strategies in high-stakes athletic environments (I sports gamble), and
                        I analyze player performance and refine approaches to gain a competitive edge in time-sensitive virtual environments (I play video games). 
                        I'm a big Atlanta Falcons fan and play games like Civilization 6.
                    </p>
                </div>
                <div className="home-content flex-column medium-gap">
                    <p className="text-body">
                        It's a fact of life that some people will never work in a field they truly love. 
                        Some passions can't turn into careers; some passions won't even be found beneath the pile of anxiety in trying new things. 
                        When I look at my life, I can't help but think: How lucky am I to be who I am where I am.
                    </p>
                    <figure>
                        <AnimatedImage alt="Networking Conference" src={require('../assets/images/conference.webp')} className="home-content__image home-content__image--large" />
                        <figcaption className="text-caption text-center">Networking Conference / University of Georgia</figcaption>
                    </figure>
                </div>
            </section>
            <div className="divider"></div>
            <aside className="home-aside flex-column large-gap">
                <figure className="home-aside__quote flex-column medium-gap">
                    <AnimatedImage alt="Train" src={require('../assets/images/train.webp')} />
                    <blockquote>
                        "Nothing in this world can take the place of persistence. Talent will not: nothing is more common than unsuccessful men with talent. Genius will not; unrewarded genius is almost a proverb... persistence and determination alone are omnipotent."<br />
                        <span className="text-caption">- Calvin Coolidge</span>
                    </blockquote>
                </figure>
                <div className="line"></div>
                <div className="flex-column medium-gap">
                    <a href="https://www.linkedin.com/in/parker-anderson-baab0820a" rel="noopener noreferrer" target="_blank" className="home-aside__article flex-row justify-start small-gap">
                        <AnimatedImage alt="LinkedIn" src={require('../assets/images/linkedin.webp')} />
                        <p>
                            Professional calls account "greatest ever" <br />
                            <span className="text-caption">3 MIN READ</span>
                        </p>
                    </a>
                    <a href="https://github.com/parkeranderson130" rel="noopener noreferrer" target="_blank" className="home-aside__article flex-row justify-start small-gap">
                        <AnimatedImage alt="GitHub" src={require('../assets/images/github.webp')} />
                        <p>
                            "When I need a boost, I look at his GitHub..." <br />
                            <span className="text-caption">3 MIN READ</span>
                        </p>
                    </a>
                    <a href="https://drive.google.com/file/d/1qdanfjeTAxatYW1Dtb1fuG3fH09gg0k2/view" rel="noopener noreferrer" target="_blank" className="home-aside__article flex-row justify-start small-gap">
                        <AnimatedImage alt="Resume" src={require('../assets/images/resume.webp')} />
                        <p>
                            10 tips to get a resume more like Parker's <br />
                            <span className="text-caption">2 MIN READ</span>
                        </p>
                    </a>
                </div>
            </aside>
        </main>
    )
}

export default Home;